export const range = (start: number, end: number, step: number = 1): number[] => {
	const list = [];

	for (let i = start; step > 0 ? i < end : i > end; i += step) {
		list.push(i);
	}

	return list;
};
